import confetti from "canvas-confetti";

// A short, on-brand confetti burst for the onboarding "setup complete" moment.
export function celebrate() {
  const colors = ["#4f46e5", "#10b981", "#f59e0b", "#6366f1"];
  const end = Date.now() + 800;
  (function frame() {
    confetti({ particleCount: 4, angle: 60, spread: 55, startVelocity: 45, origin: { x: 0, y: 0.7 }, colors });
    confetti({ particleCount: 4, angle: 120, spread: 55, startVelocity: 45, origin: { x: 1, y: 0.7 }, colors });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();
  confetti({ particleCount: 110, spread: 90, startVelocity: 40, origin: { y: 0.6 }, colors });
}
